import settingRoutes from './routes'

/* @ngInject */
const settingRoute = (
  $stateProvider
) => {
  $stateProvider
    .state(settingRoutes.index.path, {
      url: settingRoutes.index.url,
      template: require('./templates/index.html'),
      data: {
        pageTitle: 'Options',
      },
    })
}

export default settingRoute



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/setting/setting.routes.js